"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _utils = require("./utils");

var _DiscountItem = _interopRequireDefault(require("./DiscountItem.prototype"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable no-nested-ternary */

/* eslint-disable react/prop-types */

/* eslint-disable react/jsx-no-comment-textnodes */
// Author - Christian John B.


var borderStyle = (0, _styledComponents.css)(["border:1px;border-style:solid;border-color:", ";border-radius:4px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLight;
});
var marginBottom = (0, _styledComponents.css)(["margin-bottom:5px;"]);

var DiscountItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemWrapper",
  componentId: "sc-atai45-0"
})(["", ";padding:10px;font-family:", ";cursor:", ";background:", ";"], function () {
  return borderStyle;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.default;
}, function (_ref3) {
  var isEnabled = _ref3.isEnabled;
  return isEnabled ? 'pointer' : 'default';
}, function (_ref4) {
  var theme = _ref4.theme,
      isEnabled = _ref4.isEnabled;
  return isEnabled ? theme.colors.default : theme.colors.greyLighter;
});

DiscountItemWrapper.displayName = 'DiscountItemWrapper';

var DiscountItemInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemInnerWrapper",
  componentId: "sc-atai45-1"
})(["display:flex;flex-direction:row;"]);

DiscountItemInnerWrapper.displayName = 'DiscountItemInnerWrapper';

var DiscountItemSelectionWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemSelectionWrapper",
  componentId: "sc-atai45-2"
})(["margin:0 10px;"]);

var DiscountItemContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemContentWrapper",
  componentId: "sc-atai45-3"
})(["display:flex;flex-direction:column;"]);

var DiscountItemContentTitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemContentTitleWrapper",
  componentId: "sc-atai45-4"
})(["margin-bottom:5px;", ";"], function () {
  return marginBottom;
});

var DiscountItemContentTitle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentTitle",
  componentId: "sc-atai45-5"
})(["background:", ";padding:5px;color:", ";opacity:", ";border-radius:4px;font-weight:", ";line-height:18px;font-family:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryLight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.secondary;
}, function (_ref7) {
  var isEnabled = _ref7.isEnabled;
  return isEnabled ? '1' : '0.7';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.bold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
});
DiscountItemContentTitle.displayName = 'DiscountItemContentTitle';

var DiscountItemContentValidityWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemContentValidityWrapper",
  componentId: "sc-atai45-6"
})(["", ";"], function () {
  return marginBottom;
});

var DiscountItemContentValidityIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentValidityIcon",
  componentId: "sc-atai45-7"
})(["margin-right:5px;color:", ";vertical-align:middle;"], function (_ref10) {
  var theme = _ref10.theme,
      isEnabled = _ref10.isEnabled;
  return isEnabled ? theme.colors.greyDark : theme.colors.greyMedium;
});
var DiscountItemContentValidity = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentValidity",
  componentId: "sc-atai45-8"
})(["color:", ";font-family:", ";font-size:", ";vertical-align:middle;"], function (_ref11) {
  var theme = _ref11.theme,
      isEnabled = _ref11.isEnabled;
  return isEnabled ? theme.colors.greyDark : theme.colors.greyMedium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily.default;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSize.small;
});
DiscountItemContentValidity.displayName = 'DiscountItemContentValidity';
var DiscountItemContentDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentDescription",
  componentId: "sc-atai45-9"
})(["", ";color:", ";font-family:", ";font-size:", ";"], function () {
  return marginBottom;
}, function (_ref14) {
  var theme = _ref14.theme,
      isEnabled = _ref14.isEnabled;
  return isEnabled ? theme.colors.neutral : theme.colors.greyMedium;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontFamily.default;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSize.small;
});
DiscountItemContentDescription.displayName = 'DiscountItemContentDescription';
var DiscountItemContentTermsAndCondition = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentTermsAndCondition",
  componentId: "sc-atai45-10"
})(["color:", ";cursor:pointer;font-size:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.type === 'AIRASIA_MOVE' ? theme.colors.tertiaryRed : theme.colors.secondary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontSize.small;
});
DiscountItemContentTermsAndCondition.displayName = 'DiscountItemContentTermsAndCondition';

var SelectedIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__SelectedIconWrapper",
  componentId: "sc-atai45-11"
})(["", ";background:", ";width:20px;height:20px;cursor:pointer;text-align:center;"], function () {
  return borderStyle;
}, function (_ref19) {
  var theme = _ref19.theme,
      isSelected = _ref19.isSelected;
  return isSelected ? theme.colors.secondary : theme.colors.default;
});

var SelectedIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "DiscountItem__SelectedIcon",
  componentId: "sc-atai45-12"
})(["color:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.default;
});

var DiscountItemContentMinimumSpendWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemContentMinimumSpendWrapper",
  componentId: "sc-atai45-13"
})([""]);

DiscountItemContentMinimumSpendWrapper.displayName = 'DiscountItemContentMinimumSpendWrapper';

var DiscountItemContentDivider = _styledComponents.default.div.withConfig({
  displayName: "DiscountItem__DiscountItemContentDivider",
  componentId: "sc-atai45-14"
})(["border-top:1px solid #d9dbe0;margin:6px 0;"]);

var DiscountItemContentMinimumSpend = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountItem__DiscountItemContentMinimumSpend",
  componentId: "sc-atai45-15"
})(["color:", ";font-family:", ";font-size:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.yellow;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontFamily.default;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontSize.small;
});

var DiscountItem = function DiscountItem(_ref24) {
  var theme = _ref24.theme,
      translations = _ref24.translations,
      name = _ref24.name,
      id = _ref24.id,
      amount = _ref24.amount,
      description = _ref24.description,
      minSpend = _ref24.minSpend,
      isSelected = _ref24.isSelected,
      isEnabled = _ref24.isEnabled,
      hasMinSpendMessage = _ref24.hasMinSpendMessage,
      onClickTnC = _ref24.onClickTnC,
      onClickItem = _ref24.onClickItem,
      currencyCode = _ref24.currencyCode,
      hasTnC = _ref24.hasTnC,
      validity = _ref24.validity,
      locale = _ref24.locale,
      stackable = _ref24.stackable,
      bigPointsAllowed = _ref24.bigPointsAllowed;

  var validUntil = function validUntil() {
    if (!validity || !validity.endDate) return '';

    if (validity.startDate && validity.endDate) {
      var validStart = (0, _utils.formatDate)(locale, validity.startDate);
      var validEnd = (0, _utils.formatDate)(locale, validity.endDate);
      return _utilities.default.transformText(translations.validFromUntil, [validStart, validEnd]);
    }

    var discountValidity = (0, _utils.formatDate)(locale, validity.endDate);
    return _utilities.default.transformText(translations.validUntil, [discountValidity]);
  };

  var minSpendDescription = function minSpendDescription() {
    var minSpendAmountText = "".concat(currencyCode).concat(minSpend);
    return _utilities.default.transformText(translations.minSpendDesc, [minSpendAmountText]);
  };

  var _useState = (0, _react.useState)(isSelected),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      IsSelected = _useState2[0],
      setIsSelected = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsSelected(isSelected);
  }, [isSelected]);

  var clickSelectHandler = function clickSelectHandler(ev) {
    /**
     * Check if the target clicked is hyperlink then prevent toggling
     * and trigger the onClickTnC instead
     * Used for clicking TnC
     */
    if (ev.target.tagName.toLowerCase() === 'a') {
      onClickTnC();
      return;
    }

    setIsSelected(!IsSelected);
    var retunData = {
      name: name,
      isSelected: !IsSelected,
      id: id,
      amount: amount,
      description: description,
      stackable: stackable,
      bigPointsAllowed: bigPointsAllowed
    };
    onClickItem(retunData);
  };

  var clickTnCHandler = function clickTnCHandler() {
    onClickTnC();
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var MinSpendSection = function MinSpendSection() {
    return /*#__PURE__*/_react.default.createElement(DiscountItemContentMinimumSpendWrapper, null, /*#__PURE__*/_react.default.createElement(DiscountItemContentDivider, null), /*#__PURE__*/_react.default.createElement(DiscountItemContentMinimumSpend, null, minSpendDescription()));
  };

  var DiscountItemSection = function DiscountItemSection() {
    return /*#__PURE__*/_react.default.createElement(DiscountItemContentWrapper, null, /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: "AIRASIA_CLASSIC"
    }, /*#__PURE__*/_react.default.createElement(DiscountItemContentTitleWrapper, null, name && /*#__PURE__*/_react.default.createElement(DiscountItemContentTitle, {
      isEnabled: isEnabled
    }, name))), validUntil() && /*#__PURE__*/_react.default.createElement(DiscountItemContentValidityWrapper, null, /*#__PURE__*/_react.default.createElement(DiscountItemContentValidityIcon, {
      icon: _constant.ICONS.TIMER_ICON,
      fontsize: "normal",
      isEnabled: isEnabled
    }), /*#__PURE__*/_react.default.createElement(DiscountItemContentValidity, {
      isEnabled: isEnabled
    }, validUntil())), /*#__PURE__*/_react.default.createElement(DiscountItemContentDescription, {
      isEnabled: isEnabled
    }, description), /*#__PURE__*/_react.default.createElement(DiscountItemContentTermsAndCondition, {
      onClick: clickTnCHandler
    }, hasTnC && translations.tnc), hasMinSpendMessage && MinSpendSection());
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(DiscountItemWrapper, {
      isEnabled: isEnabled,
      onClick: isEnabled ? clickSelectHandler : null
    }, /*#__PURE__*/_react.default.createElement(DiscountItemInnerWrapper, null, /*#__PURE__*/_react.default.createElement(DiscountItemSelectionWrapper, null, /*#__PURE__*/_react.default.createElement(SelectedIconWrapper, {
      isSelected: IsSelected
    }, IsSelected && /*#__PURE__*/_react.default.createElement(SelectedIcon, {
      icon: _constant.ICONS.CHECK_ICON
    }))), DiscountItemSection()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

DiscountItem.propTypes = _DiscountItem.default.PropTypes;
DiscountItem.defaultProps = _DiscountItem.default.DefultProps;
var _default = DiscountItem;
exports.default = _default;